import { ContentfulImage } from '@ecomm/contentful-components'
import type { ContentfulImageSchema } from '@ecomm/contentful-components'
import classNames from 'classnames'

import type { ServiceMenuItem } from '../data'

type MenuItem = ServiceMenuItem & {
  readonly image?: ContentfulImageSchema
}

type MenuItemContentProps = {
  readonly item: MenuItem
  readonly index: number
  readonly menuItemsLength: number
}

export function MenuItemContent({
  item,
  index,
  menuItemsLength
}: MenuItemContentProps) {
  return (
    <div
      className={classNames(
        'flex flex-nowrap items-center border-0 border-b border-solid border-b-neutral-300 py-4 min-[1126px]:mx-5 min-[1126px]:w-[215px] min-[1126px]:flex-row min-[1126px]:flex-wrap min-[1126px]:border-b-0 min-[1126px]:py-0',
        index === menuItemsLength - 1 && 'px-4 min-[1126px]:px-0'
      )}
    >
      <div className="flex w-1/2 flex-wrap min-[1126px]:w-auto">
        <span
          className={classNames(
            'mb-2 mr-6 w-full text-base font-bold min-[1126px]:mr-0 min-[1126px]:w-full min-[1126px]:whitespace-nowrap'
          )}
        >
          {item.text}
        </span>
      </div>
      {item.image ? (
        <div
          className="flex w-1/2 justify-end min-[1126px]:w-auto"
          data-testid={`services-dropdown-image-${index}`}
        >
          <ContentfulImage
            className="mr-3 h-[75px] w-[110px] rounded-xl md:h-[95px] md:w-[145px] min-[1126px]:h-[145px] min-[1126px]:w-[215px]"
            {...item.image}
            quality={90}
            width={215}
          />
        </div>
      ) : null}
    </div>
  )
}
